'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { GameLauncherEvents } from './constants';

export const useGameLauncherEvents = ({ triggerEntryCall, fetchRewardsMachineContent }: any) => {
    const router = useRouter();

    useEffect(() => {
        const messageHandler = (event: any) => {
            switch (event?.data?.type) {
                case GameLauncherEvents.IncentiveGameRedirect:
                    router.push(event.data.payload);
                    break;
                case GameLauncherEvents.IncentiveGameUpdate:
                case GameLauncherEvents.ReloadSpins:
                    triggerEntryCall?.();
                    break;
                case GameLauncherEvents.GameClosed:
                case GameLauncherEvents.GameLauncherClose:
                    fetchRewardsMachineContent?.();
                    break;
                default:
                    break;
            }
        };

        window.addEventListener('message', messageHandler);

        return () => window.removeEventListener('message', messageHandler);
    }, []);
};
